import CircularProgress from "@mui/material/CircularProgress";
import React from 'react';
import { useHistory } from "react-router-dom";
import { CreateYahrzeitAlertAction, CreateYahrzeitAlertButton, CreateYahrzeitAlertContainer, CreateYahrzeitAlertTitle } from './Theme';

const CreateYahrzeitAlert = ({ closeModal, user }) => {
  const history = useHistory();
  const navigateToCreateYahrzeit = () => {
    history.push({
      pathname: `/member-details/${user?.account_id}`,
      state: {
        activeTab: "Yahrzeits",
        openCreateYahrzeit: true,
      }
    });
    closeModal();
  }

  return (
    <CreateYahrzeitAlertContainer>
      <CreateYahrzeitAlertTitle>Would you like to create a Yahrzeit?</CreateYahrzeitAlertTitle>
      <CreateYahrzeitAlertAction>
        <CreateYahrzeitAlertButton className="btn btn-primary font-weight-bold px-6 py-3" onClick={navigateToCreateYahrzeit}>
          Create a Yahrzeit
        </CreateYahrzeitAlertButton>
      </CreateYahrzeitAlertAction>
    </CreateYahrzeitAlertContainer>
  )
}

export default CreateYahrzeitAlert